import { request } from "@/components/Joyspace/api/request";
import { Method, pwaAttribute } from "@/attributes/pwaAttribute";
import joyspaceController from "../controllers/JoyspaceController";

class TagApi {
  @pwaAttribute(Method.get, joyspaceController, "getTags", "setTags")
  queryTags() {
    return request({
      api: "joyspace.tag.query",
      path: "/v1/tags/0",
      method: "GET"
    }).catch(() => []);
  }
  // 标签-打标文档列表
  @pwaAttribute(Method.get, joyspaceController, "getList", "setList")
  listByTag(params: {
    tagId: number;
    length: number;
    sort?: string;
    order?: string;
    start: number;
  }) {
    return request({
      api: "joyspace.pages.listByTag",
      path: "/v1/pages/listByTag",
      params
    });
  }
}
// 创建标签
export function createTag(body: { name: string }) {
  return request({
    api: "joyspace.tag.create",
    path: "/v1/tags/create",
    method: "POST",
    body
  });
}
// 删除标签
export function deleteTag(body: { id: string }) {
  return request({
    api: "joyspace.tag.delete",
    path: "/v1/tags/delete",
    method: "DELETE",
    body
  });
}

// 修改标签
export function updateTag(body: { id: string; name: string }) {
  return request({
    api: "joyspace.tag.update",
    path: "/v1/tags/update",
    method: "PUT",
    body
  });
}
// 从标签的文档列表中移除文档
export function deleteTagsRecords(body: {
  bizId: "string";
  bizType: number | string;
  tagIds: string[];
}) {
  return request({
    api: "joyspace.tag.deleteRecords",
    path: "/v1/tags/biz",
    method: "DELETE",
    body
  });
}
const tagApi = new TagApi();

export const listByTag = (params: {
  tagId: number;
  length: number;
  sort?: string;
  order?: string;
  start: number;
}) => tagApi.listByTag(params);
export const queryTags = () => tagApi.queryTags();
